document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('media-gallery').forEach((gallery) => {
    const viewer = gallery.querySelector('slider-component[id^="GalleryViewer"]');
    if (!viewer) return;

    const prevButton = viewer.querySelector('.slider-button--prev');
    const nextButton = viewer.querySelector('.slider-button--next');

    const getThumbnails = () => {
      return Array.from(
        gallery.querySelectorAll('button[aria-controls^="GalleryViewer"]')
      ).filter((button) => {
        return button.offsetParent !== null;
      });
    };

    const goToMedia = (direction) => {
      const thumbnails = getThumbnails();
      if (!thumbnails.length) return;

      let currentIndex = thumbnails.findIndex(
        (button) => button.getAttribute('aria-current') === 'true'
      );

      if (currentIndex === -1) currentIndex = 0;

      const nextIndex =
        (currentIndex + direction + thumbnails.length) % thumbnails.length;

      thumbnails[nextIndex].click();
    };

    if (prevButton) {
      prevButton.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          goToMedia(-1);
        },
        true
      );
    }

    if (nextButton) {
      nextButton.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          goToMedia(1);
        },
        true
      );
    }
  });
});